import React from 'react'
import "./ForumSection.css"
import faceBookIcon from '../../assets/images/facebook-icon.svg'
import instagramIcon from '../../assets/images/instagram-icon.svg'
import facebookuserImage from '../../assets/images/default-avatar-2022-1.jpg'
import reviewRating from '../../assets/images/review-rating.svg'
import forumAvatarThree from '../../assets/images/default-avatar-2020-21-1.jpg'
import eyeBlogImage from '../../assets/images/eyetravelblog.png'
import dianedImage from '../../assets/images/default-avatar-2020-1dsdd.jpeg'

const ForumSection = () => {
  return (
    <>
        <div className='uk-section trip-background-mustard uk-height-viewport'>
            <div className='uk-container'  uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-medium; delay: 200; offset-top: 50; repeat: true;">


            <div className="uk-grid-small uk-grid" >
                    <div className='uk-width-1-2@l uk-width-1-1@m uk-margin-remove-bottom uk-scrollspy-inview' uk-scrollspy-class="uk-animation-slide-bottom-medium">
                        <div className='trip-black trip-heading-display trip-ultra'>
                            We had each other’s backs <br className="uk-visible@l" />with good recs, inside tips, and a pep talk or two.
                        </div>
                    </div>

                    <div className='uk-width-1-2@l' >

                        {/* First Review  */}
                        <div className='forum-top-right forum-margin-top' uk-scrollspy-class="">

                            <div className=' uk-card uk-card-border forum-review-container'>
                                <div className='uk-badge uk-card-badge forum-badge'>
                                    <img src={faceBookIcon} alt="Facebook Icon" className='forum-badge-icon' />
                                </div>

                                <div className='uk-grid uk-grid-collapse'>

                                    <div className='uk-width-auto'>

                                        <div className='uk-text-center uk-margin-auto'>

                                        <div className='forum-review-avatar uk-text-center'>

                                            <img src={facebookuserImage} alt="User Avatar" className='forum-avatar uk-border-circle' />

                                        </div>

                                        <div className='forum-review-user uk-text-center'>
                                        Jan S. via <br/>Facebook
                                        </div>

                                        </div>

                                    </div>



                                    <div className='uk-width-2-3'>
                                        <div className=''>
                                            <div className='forum-review-content'>
                                            Sentenil de de las Bodegas and Olvera are spectacular…and you can look forward to Cádiz…it’s so beautiful.

                                            </div>
                                        </div>

                                    </div>

                            </div>
                        </div>

                    </div>


                    {/* Second Review */}
                    <div className='forum-margin-top forum-move-left' uk-scrollspy-class="">

                        <div className=' uk-card uk-card-border forum-review-container'>
                                    <div className='uk-badge uk-card-badge forum-badge'>
                                        <img src={instagramIcon} alt="Facebook Icon" className='forum-badge-icon' />
                                    </div>

                                    <div className='uk-flex uk-flex'>

                                        <div className='uk-width-auto'>

                                            <div className='uk-text-center uk-margin-auto'>

                                            <div className='forum-review-avatar uk-text-center'>

                                                <img src={eyeBlogImage } alt="User Avatar" className=' uk-border-circle' />

                                            </div>

                                            <div className='forum-review-user uk-text-center'>
                                            @eyetravelblog  <br/>via Instagram
                                            </div>

                                            </div>

                                        </div>



                                        <div className='uk-width-2-3'>
                                            <div className=''>
                                                <div className='forum-review-content'>
                                                La Playita, a restaurant that's a block away, has fantastic food. And you can also do a sunrise paddleboarding from a hostel thats 2 blocks away also.
                                                </div>
                                            </div>

                                        </div>

                                </div>
                            </div>

                        </div>

                    </div>
                     {/* End of Second Review */}
            </div>
            {/* End of top row  */}


{/* Second Row */}
<div className='forum-margin-top forum-move-right' uk-scrollspy-class="">

            <div className='uk-grid-small uk-grid '>

                <div className='uk-width-1-2@l uk-width-1-1@m'>

                </div>

                <div className='uk-width-1-2@l uk-width-1-1@m'>

                    <div className='uk-card uk-card-border forum-slim-review-container'>

                        <div className='forum-slim-rating'>
                                <img src={reviewRating} alt="Star Rating" className=''/>
                        </div>

                        <div className='forum-slim-content'>
                        Try the alpaca meat and beer at the top.
                        </div>

                        <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                <div className="uk-margin-small-left forum-slim-review-user">
                                @486rafaellag
                                </div>
                                <div className=" uk-flex-first">
                                    <img src={forumAvatarThree} alt="User Avatar" className='forum-slim-avatar uk-border-circle'/>
                                </div>
                        </div>
                                



                        <div className='forum-slim-review-footer'>
                        Review of Rainbow Mountain Cusco
                        </div>

                    </div>

                </div>

            </div>
</div>
{/* End of Second Row */}


{/* Third Row */}

<div className='forum-margin-top forum-move-right' uk-scrollspy-class="">

            <div className='uk-grid-small uk-grid '>

            <div className='uk-width-1-2@l'>

</div>


                <div className='uk-width-1-2@l '>

                    <div className='uk-card uk-card-border forum-slim-review-container final-forum-move-right'>

                        <div className='forum-slim-rating'>
                                <img src={reviewRating} alt="Star Rating" className=''/>
                        </div>

                        <div className='forum-slim-content'>
                        To future zip liners I would just say wrap up warmly especially in colder months and give something that could be out of your comfort zone a go.
                        </div>

                        <div className="uk-flex uk-flex-middle forum-slim-user-info">
                                <div className="uk-margin-small-left forum-slim-review-user">
                                @dianedF5402CP
                                </div>
                                <div className=" uk-flex-first">
                                    <img src={dianedImage} alt="User Avatar" className='forum-slim-avatar uk-border-circle'/>
                                </div>
                        </div>
                                



                        <div className='forum-slim-review-footer'>
                        Review of Ziplining Forest Adventure - The Original Canopy Tour Rotorua
                        </div>

                    </div>

                </div>



            </div>
</div>



{/* End of Third */}




        </div>
    </div>

    </>

  )
}

export default ForumSection